import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/workshops/${id}`)
    },
    list(params) {
        return Vue.axios.get(`/workshops`, {params})
    },
    create(params) {
        return Vue.axios.post(`/workshops/create`, params)
    },
    remove(id) {
        return Vue.axios.get(`/workshops/remove/${id}`)
    },
    update(params) {
        return Vue.axios.post(`/workshops/update`, params)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
